//日期转时间戳，用来比较大小
export function dateToTimestamp(dateString) {
    if (dateString.includes('_') && dateString.includes('-') && dateString.includes(':')) {
        const [datePart, timePart] = dateString.split('_');
        const [year, month, day] = datePart.split('-');
        const [hour, minute] = timePart.split(':');
        const timestamp = new Date(year, month - 1, day, hour, minute).getTime();
        return timestamp;
    }
    else {
        return dateString
    }
}
//时间戳转日期，用来显示文本
export function timestampToDate(timestamp) {
    if (timestamp) {
        let str = new Date(timestamp).toLocaleString();
        return str;
    }
    else {
        return ''
    }
}
//提取数字
export function getNumber(str) {
    let res = str.match(/\d+/)
    if (!res) return -1
    if (res[0]) {
        return Number(res[0])
    }
    else throw new Error('Regx Get Number Failed')
}
//提取数字
export function setString(obj) {
    let str = JSON.stringify(obj ? obj : '')
    return str
}